import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Swiper, { Navigation, Thumbs, A11y } from 'swiper';

const GeneralCarousel = () => {
    const [swiperInstance, setSwiperInstance] = useState(null as Swiper);

    useEffect(() => {
        initGeneralGallery();
    }, []);

    const initGeneralGallery = () => {
        const carousel = document.getElementById('may-we-suggest');
        //swiper
        const swiperGallery = new Swiper(carousel, {
            modules: [Navigation, Thumbs, A11y],
            direction: 'horizontal',
            freeMode: false,
            // loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            navigation: {
                nextEl: '.carousel-button-next',
                prevEl: '.carousel-button-prev',
            },
            watchSlidesProgress: true,
            a11y: { enabled: true },
            breakpoints: {
                // when window width is >= 768
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 0,
                },
                // when window width is >= 768
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 0,
                },
            },
        });
        setSwiperInstance(swiperGallery);
    };

    return <></>;
};

export default GeneralCarousel;
